<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 32"
    class="icon-svg icon-amex"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1232 -906) translate(1176 140) translate(0 614) translate(0 152) translate(56)"
      >
        <rect
          width="47"
          height="31"
          x=".5"
          y=".5"
          stroke="#d5d5d5"
          fill="#FFFFFF"
          rx="4"
        />
        <g fill-rule="nonzero">
          <path
            fill="#FF5F00"
            d="M11 2L19 2 19 15 11 15z"
            transform="translate(10 8)"
          />
          <path
            fill="#EB001B"
            d="M10.695 8C10.694 5.544 11.913 3.225 14 1.71 10.452-.867 5.36-.493 2.296 2.572c-3.061 3.063-3.061 7.792 0 10.855 3.063 3.065 8.154 3.44 11.703.863-2.088-1.514-3.308-3.835-3.306-6.291h.002z"
            transform="translate(10 8)"
          />
          <path
            fill="#F79E1B"
            d="M27.19 13.791v-.812h.175v-.167h-.418v.167h.165v.812h.077zm.81 0v-.98h-.126l-.148.7-.147-.7h-.126v.98h.09v-.741l.137.636h.095l.137-.636v.741H28zm-.065-5.79c0 3.062-1.883 5.856-4.849 7.195-2.966 1.338-6.492.986-9.086-.907 2.077-1.515 3.29-3.834 3.29-6.29 0-2.454-1.213-4.772-3.29-6.288 2.594-1.893 6.12-2.245 9.086-.907 2.965 1.336 4.848 4.13 4.85 7.195V8z"
            transform="translate(10 8)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
